import type { ApiMessageTemplateGroupSimpleModel, MessageTemplateResponse } from '@/core/generated/api';
import type { ColumnConfig } from '@/shared/ui/DataTable/DataTable';

/** Колонки тематических групп */
export const MESSAGE_TEMPLATE_GROUP_COLUMNS: ColumnConfig<ApiMessageTemplateGroupSimpleModel>[] = [
    {
        field: 'name',
        header: 'Группа текстовок',
    },
];

/** Колонки текстовок выбранной группы */
export const MESSAGE_TEMPLATE_COLUMNS: ColumnConfig<MessageTemplateResponse>[] = [
    {
        field: 'description',
        header: 'Где используется',
        body: (row) => row.description || row.code?.name || '—',
    },
    {
        field: 'text',
        header: 'Текст сообщения',
    },
];
